

















































import { Component, Prop, Vue } from "vue-property-decorator";
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import TDSButton from "@/components/common/TDSButton.vue";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import Inputfield from "@/components/partials/Inputfield.vue";
import { Roles, User } from "@/interfaces/entities/User";
import CountryPicker from "@/components/partials/CountryPicker.vue";
import { Country } from "@/interfaces/Country";
import countryHelper from "@/util/countries";
import { Account } from "@/interfaces/entities/Account";

@Component({
    components: { Inputfield, TDSModal, TDSButton, DefaultLayout, CountryPicker }
})
export default class Profile extends Vue {
    private firstName: string = "";
    private lastName: string = "";
    private email: string = "";
    private showModal: boolean = false;
    private updatingUser: boolean = false;

    get isMobile(): boolean {
        return this.$store.state.isMobile;
    }

    get account(): Account {
        return this.$store.state.account;
    }

    get role(): string {
        return Object.keys(Roles).find((element: string) => {
            const value = (Roles as any)[element] as string;
            return (this.$store.state.account.authorities.includes(value));
        })?.toString() || "";
    }

    created() {
        document.title = process.env.VUE_APP_THEME_TITLE + " | " + this.$t("account.details.pageTitle");
    }

    private showUpdateModal() {
        this.firstName = this.account.firstName;
        this.lastName = this.account.lastName;
        this.email = this.account.email;
        this.showModal = true;
    }

    private async updateUser() {
        if (this.updatingUser) return;
        this.updatingUser = true;
        try {
            await this.$store.dispatch("UPDATE_PROFILE", {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email
            });
            this.showModal = false;
        } catch (e) {
            if (e.response && e.response.data && e.response.data.message) this.$toastr.error(e.response.data.message);
            else this.$toastr.error("Failed updating personal information");
        } finally {
            this.updatingUser = false;
        }
    }
}
